import { Link } from 'react-router';

import { getBrandsForPet } from '@/data/brands';
import { PET_TYPES } from '@/lib/taxonomy';
import { WA_LINKS } from '@/lib/whatsapp';

import { BrandTile } from '../commerce/BrandTile';
import { Section, SectionHeading } from '../common/Section';
import { WhatsAppIcon } from '../common/icons';
import { Button } from '../ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';

export function BrandShowcase() {
  return (
    <Section tone="sand" size="md" container="md">
      <SectionHeading
        eyebrow="Nosso portfólio"
        title="Trabalhamos com as melhores marcas"
        description="Do custo-benefício ao super premium importado. Toque em uma marca para ver os produtos disponíveis."
        className="mb-8"
      />

      <Tabs defaultValue="dog" className="flex flex-col items-center gap-8">
        <TabsList>
          {(['dog', 'cat'] as const).map((pet) => (
            <TabsTrigger key={pet} value={pet}>
              <span aria-hidden="true">{PET_TYPES[pet].emoji}</span>
              Para {PET_TYPES[pet].label.toLowerCase()}
            </TabsTrigger>
          ))}
        </TabsList>

        {(['dog', 'cat'] as const).map((pet) => (
          <TabsContent key={pet} value={pet} className="w-full">
            <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
              {getBrandsForPet(pet).map((brand) => (
                <li key={brand.id}>
                  <BrandTile brand={brand} to={`/catalogo?pet=${pet}&brand=${brand.id}`} />
                </li>
              ))}
            </ul>
          </TabsContent>
        ))}
      </Tabs>

      <div className="mt-10 flex flex-col items-center gap-3 text-center">
        <p className="font-semibold text-brown-700">Não encontrou a marca que o seu pet usa?</p>

        <div className="flex flex-col gap-2 sm:flex-row">
          <Button asChild variant="whatsapp" size="md">
            <a href={WA_LINKS.brandRequest} target="_blank" rel="noopener noreferrer">
              <WhatsAppIcon aria-hidden="true" />
              Perguntar no WhatsApp
            </a>
          </Button>

          <Button asChild variant="outline" size="md">
            <Link to="/marcas">Conhecer todas as marcas</Link>
          </Button>
        </div>
      </div>
    </Section>
  );
}
